// extracted by mini-css-extract-plugin
module.exports = {"popup":"bubble_popup__65o6Q","peak":"bubble_peak__NM3J6","variant":"bubble_variant__gZNKk"};